var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pro-layout"},[(_vm.path!=='/home' && _vm.path!=='/COIEvaluationReport')?_c('div',{staticClass:"pro-layout-header"},[_vm._t("header")],2):_vm._e(),_c('div',{staticClass:"pro-layout-body",style:(_vm.path==='/home'?'height:100vh':'')},[_vm._t("default"),_vm._t("footer")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }